import React, { Component } from 'react';

class BotMessageWrap extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <React.Fragment>
               {this.props.children} 
            </React.Fragment>
        )
    }
}
BotMessageWrap.propTypes = {
    children: React.propTypes.node
}
export default BotMessageWrap;